import Price                                    from "components/Price/Price"
import Spinner                                  from "components/Spinner/Spinner"
import { action, observable }                   from "mobx"
import { observer }                             from "mobx-react"
import PropTypes                                from "prop-types"
import React, { Component }                     from "react"
import { Link }                                 from "react-router-dom"
import { Col, FormInput, InputGroup, Row }      from "elemental-react16"
import { Button, Input, Label, Modal, Segment } from "semantic-ui-react"
import shop                                     from "shop/shop"
import CartTotal                                from "components/Cart/CartTotal"
import ProductTable                             from "components/Product/ProductTable"
import HeaderCheckout                           from "./HeaderCheckout"
import _                                        from "lodash"
import "style/CheckoutPage.scss"
import CartExport                               from "components/Cart/CartExport"

class DiscountStore {
  @observable discountByPosition = {}
  
  @action
  setDiscount( product, discount ) {
    product.setDiscount( discount )
    this.discountByPosition[ product.map_id ] = discount
    this.discountByPosition = _.clone( this.discountByPosition )
  }
  
  @action
  loadFromCart() {
    shop.cart.products.forEach( p => {
      this.setDiscount( p, Math.abs( p.extras.custom_discount || p.extras.rabatt ) )
    } )
  }
  
  @action
  async saveDiscounts() {
    
    _.each( this.discountByPosition, ( discount, map_id ) => {
      const product = shop.cart.productsById.get( map_id )
      if ( product ) product.setDiscount( discount )
    } )
    
    await shop.cart.saveImmediate()
    await shop.cart.get()
  }
  
}

const discountStore = new DiscountStore()
window.discountStore = discountStore

export default class CheckoutDiscountPage extends Component {
  
  state = {
    products: getProducts(),
    discountRate: 0,
    loading: false
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    discountStore.loadFromCart()
    shop.cart.update()
  }
  
  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }
  
  updateCart = () => {
    let products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  handleDiscount = ( event ) => {
    let { value } = event.target
    value = Number( value )
    value = Math.max( 0, value )
    value = Math.min( 100, value )
    this.setState( { discountRate: value } )
    shop.cart.update()
  }
  
  setDiscount = () => {
    const { discountRate } = this.state
    let products = getProducts()
    products.forEach( product => {
      product.extras._custom_discount = discountRate
      product.extras.custom_discount = -1 * discountRate
      product.setDiscount( discountRate )
      discountStore.setDiscount( product, discountRate )
    } )
    
    this.setState( { products } )
  }
  
  render() {
    let { products, discountRate, loading } = this.state
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    return (
      <div className=" ">
        {loading && <Modal open>
          <Modal.Content>
            <div className="pb4 pt3 tc">
              <div className={"pb3"}>{translate( "Warenkorb wird gespeichert." )}</div>
              <Spinner/>
            </div>
          </Modal.Content>
        </Modal>}
        <HeaderCheckout activeStep={"discount"} isRequest={isRequest}/>
        <section className="container">
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products} row={DiscountRow} lastCol={"Discount"}/>
          <Segment>
            <div className="flex justify-end">
              <div className="pr2">
                <Input labelPosition="left"
                       type="number"
                       min={0}
                       max={100}
                       value={discountRate}
                       onChange={this.handleDiscount}
                >
                  <Label basic>%</Label>
                  <input/>
                </Input>
              </div>
              <Button
                onClick={this.setDiscount}
              >{translate( "Rabatt für alle Positionen" )}</Button>
            </div>
          
          </Segment>
          <div className="fr">
            <CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
          </div>
        </section>
        
        <section className="pa2 mb4 ">
          <div className="container">
            <Row>
              <Col xs="1/2"
                   className="tl fl checkout-control">
                <Link to="/checkout/">
                  <Button>
                    <i className="icon-angle-left"/>
                    {translate( "Zurück" )}
                  </Button>
                </Link>
              </Col>
              <Col xs="1/2" className="tr fr checkout-control">
                <Button
                  onClick={() => {
                    this.setState( { loading: true } )
                    discountStore.saveDiscounts()
                    window.setTimeout( () => {
                      this.props.history.push( "/checkout/delivery/" )
                    }, 4000 + shop.cart.size * 50 )
                  }}
                  primary>
                  {translate( "Rabatt speichern & weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Col>
            </Row>
          </div>
        </section>
        
        <section>
          <div className="container">
            <CartExport/>
          </div>
        </section>
      
      </div>
    )
  }
}

class DiscountRow extends Component {
  
  state = {}
  
  handleDiscount = ( { product } ) => {
    console.log( "discount" )
    this.setState( { update: true } )
    shop.cart.update()
  }
  
  render() {
    let { product, onChange, list, cart, index } = this.props
    
    return (
      <tr>
        <td>
          {cart ? <CartActions cart={cart} product={product}/> : null}
        </td>
        <td>
          <div>
            <div className="fl pr2 w-100 mw3">
              <Link to={`/product/${product.map_id}`}>
                <img
                  className="db center"
                  height="34"
                  src={product.img_src_small}
                  alt=""/>
              </Link>
            </div>
            <Link to={`/product/${product.map_id}`}>
              <div className={"b"}>{product.article_nr}</div>
              <div className="product-title">{product.desc.des}</div>
              {/*<span className="unit_multi black-50">VE {product.unit_multi} {translate( "cart.piece" )}</span>*/}
            </Link>
          </div>
        </td>
        <td><span className="f6">{product.getNotice( "tiny" )}</span></td>
        <td>
          <div><Price>{product.price * product.unit_multi}</Price></div>
          {!!product.extras.custom_discount && <Label color="green"><Price>{product.extras.custom_price}</Price></Label>}
        </td>
        <td className="tr">
          <div><Price>{product.price * product.count * product.unit_multi}</Price></div>
          {!!product.extras.custom_discount && <Label color="green"><Price>{product.extras.custom_price_sum}</Price></Label>}
        </td>
        {/*<td><DropdownQuantities product={product} onChange={onChange}/></td>*/}
        <td className="tr">
          <div className="flex">
            {product.count * product.unit_multi}
          </div>
        </td>
        <td>
          <DiscountInput onChange={this.handleDiscount} product={product} discount={product.extras._custom_discount}/>
        </td>
      </tr>
    )
  }
}

DiscountRow.propTypes = {
  product: PropTypes.any,
  onChange: PropTypes.any,
  list: PropTypes.any,
  cart: PropTypes.any,
  index: PropTypes.any
}

// TODO
@observer
class DiscountInput extends Component {
  
  state = {
    discount: 0
  }
  
  render() {
    let { product, discount } = this.props
    let { discountByPosition } = discountStore
    let value = Number( discountByPosition[ product.map_id ] )
    if ( !value ) value = 0
    return <Input
      onChange={event => {
        let { value } = event.target
        value = Number( value )
        value = Math.max( 0, value )
        value = Math.min( 100, value )
        
        discountStore.setDiscount( product, value )
        
        this.setState( { discount: value } )
        this.props.onChange( { product } )
      }}
      labelPosition="right" type="number" min={0} max={100} value={value}>
      <input/>
      <Label basic>%</Label>
    </Input>
  }
}

DiscountInput.propTypes = { product: PropTypes.any }


const CartActions = ( { cart, product } ) => {
  return (
    <Button
      onClick={() => {
        cart.remove( product )
      }}
      basic
      icon="cancel"
      size="tiny"
    />
  )
}

CartActions.propTypes = {
  cart: PropTypes.object,
  product: PropTypes.object,
}

const Typeahead = () => {
  let refs = null
  return (
    <InputGroup contiguous>
      <InputGroup.Section grow>
        <FormInput
          ref={( context ) => refs = context && context.refs}
          type="text"
          placeholder={translate( "Artikel Nr." )}/>
      </InputGroup.Section>
      <InputGroup.Section>
        <Button onClick={() => {
          shop.product( refs.input.value )
              .then( p => {
                p.count = 1
                shop.cart.add( p )
              } )
        }}>Artikel hinzufügen</Button>
      </InputGroup.Section>
    </InputGroup>
  )
}

const getProducts = () => shop.cart.map( ( product ) => product )



// WEBPACK FOOTER //
// ./src/pages/checkout/CheckoutDiscountPage.js